import { BaseFilters } from "./common";

export type BannersFiltersType = BaseFilters & {
  Status?: string;
};

export enum BannerSizeToSort {
  Default = 1,
  Tablet = 2,
  MobileSite = 3,
}

export enum BannerSize {
  Default = "Default",
  Tablet = "Tablet",
  MobileSite = "MobileSite",
}

type BannerEntityBase = {
  Id: string;
  StartPublish: string;
  EndPublish: string;
  Name: string;
  LocationKey: string;
  LocationName: string;
  LocationId: string;
  ImageUri: string;
  IsHidden: boolean;
  TransitionUri: string;
  DisclaimerText?: string;
  Status: string;
  Author: string;
  BannerImages: {
    Size: BannerSize;
    ImageUri: string;
  }[];
};

type AdvertisementRequiredFields = {
  IsAdvertisement: true;
  AdvertiserName: string;
  AdvertiserInn: string;
  Erid: string;
};

type AdvertisementOptionalFields = {
  IsAdvertisement?: false;
  AdvertiserName?: string;
  AdvertiserInn?: string;
  Erid?: string;
};

export type BannerEntity = BannerEntityBase & (AdvertisementRequiredFields | AdvertisementOptionalFields);

export type BannersResponce = {
  banners: BannerEntity[];
  count: number;
};

export type BannerLocation = {
  Id: string;
  Name: string;
  Width: number;
  Height: number;
  LocationKey: string;
  AccessToLocation: string;
  MaxCountImage: number;
  CurrentCountImage: number;
  DeviceImageSlots: {
    BannerLocationDbId: string;
    Height: number;
    Id: string;
    Size: BannerSize;
    Width: number;
  }[];
};
